// extracted by mini-css-extract-plugin
module.exports = {"targetGroup":"targetGroup_targetGroup__BUnjF","targetGroupLink":"targetGroup_targetGroupLink___bUAT"};